import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  headerHeight: WritableSignal<number> = signal(0);
  isBannerAnimationDisabled = false;
  private isHeaderResizeActive = false;

  constructor() {}

  activate(): boolean {
    if (this.isHeaderResizeActive) {
      return false;
    }
    this.isHeaderResizeActive = true;
    return true;
  }

  setHeaderHeight(height: number) {
    this.headerHeight.set(height);
  }

  deactivate(): void {
    this.isHeaderResizeActive = false;
  }
}
